import { getBaseApiUrl } from '@fourthwall/env';
import { ApiBase } from '../ApiBase';
class CreatorIntegrationsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getCreatorIntegrations = () => {
            return this.get('/api/creator-integrations');
        };
        this.deleteCreatorIntegration = (params) => {
            return this.delete(`/api/creator-integrations/${params.app}`);
        };
        this.getTwitchAuthorization = (params) => {
            return this.get('/api/creator-integrations/twitch/authorization', params, undefined, { withCredentials: true });
        };
        this.getTwitchToken = (params) => {
            return this.get('/api/creator-integrations/twitch/token', params, undefined, { withCredentials: true });
        };
        this.getBeehiivConfiguration = () => {
            return this.get('/api/creator-integrations/beehiiv/configuration');
        };
        this.updateBeehiivConfiguration = (requestBody) => {
            return this.post('/api/creator-integrations/beehiiv/configuration', requestBody);
        };
        this.deleteBeehiivConfiguration = () => {
            return this.delete('/api/creator-integrations/beehiiv/configuration');
        };
        this.getLayloConfiguration = () => {
            return this.get('/api/creator-integrations/laylo/configuration');
        };
        this.updateLayloConfiguration = (requestBody) => {
            return this.post('/api/creator-integrations/laylo/configuration', requestBody);
        };
        this.deleteLayloConfiguration = () => {
            return this.delete('/api/creator-integrations/laylo/configuration');
        };
        this.getTiktokPartnerConfiguration = () => {
            return this.get('/api/creator-integrations/tiktok-partner/configuration');
        };
        this.updateTiktokPartnerConfiguration = (requestBody) => {
            return this.put('/api/creator-integrations/tiktok-partner/configuration', requestBody);
        };
        this.updateTiktokPartnerConfigurationStatus = (requestBody) => {
            return this.put('/api/creator-integrations/tiktok-partner/configuration/status', requestBody);
        };
        this.deleteTiktokPartnerConfiguration = () => {
            return this.delete('/api/creator-integrations/tiktok-partner/configuration');
        };
        this.getTiktokPartnerWarehouses = () => {
            return this.get('/api/creator-integrations/tiktok-partner/warehouses');
        };
        this.getTiktokPartnerShops = () => {
            return this.get('/api/creator-integrations/tiktok-partner/get_authorized_shop');
        };
        this.getTiktokPartnerProducts = () => {
            return this.get('/api/creator-integrations/tiktok-partner/products');
        };
        this.reloadTiktokPartnerProducts = () => {
            return this.post('/api/creator-integrations/tiktok-partner/products/reload');
        };
        this.getKitConfiguration = () => {
            return this.get('/api/creator-integrations/kit/configuration');
        };
        this.getKitSyncStatus = () => {
            return this.get('/api/creator-integrations/kit/sync');
        };
        this.createKitSyncJob = (requestBody) => {
            return this.post('/api/creator-integrations/kit/sync', requestBody);
        };
        this.getKlaviyoConfiguration = () => {
            return this.get('/api/creator-integrations/klaviyo/configuration');
        };
        this.refreshKlaviyoLists = () => {
            return this.post('/api/creator-integrations/klaviyo/refresh-lists');
        };
        this.setKlaviyoLists = (requestBody) => {
            return this.post('/api/creator-integrations/klaviyo/set-lists', requestBody);
        };
        this.getKlaviyoSyncStatus = () => {
            return this.get('/api/creator-integrations/klaviyo/sync');
        };
        this.createKlaviyoSyncJob = (requestBody) => {
            return this.post('/api/creator-integrations/klaviyo/sync', requestBody);
        };
        this.getMailchimpConfiguration = () => {
            return this.get('/api/creator-integrations/mailchimp/configuration');
        };
        this.getMailchimpSyncStatus = () => {
            return this.get('/api/creator-integrations/mailchimp/sync');
        };
        this.refreshMailchimpLists = () => {
            return this.post('/api/creator-integrations/mailchimp/refresh-lists');
        };
        this.createMailchimpSyncJob = (requestBody) => {
            return this.post('/api/creator-integrations/mailchimp/sync', requestBody);
        };
        this.createMailchimpStore = (requestBody) => {
            return this.post('/api/creator-integrations/mailchimp/create-store', requestBody);
        };
        this.getPledgeShopCharity = (params) => {
            return this.get(`/api/pledge/shop/${params.shopId}/charity`);
        };
        this.setPledgeShopCharity = (params, requestBody) => {
            return this.put(`/api/pledge/shop/${params.shopId}/charity`, requestBody);
        };
        this.setPledgeShopCharityPercentage = (params, requestBody) => {
            return this.put(`/api/pledge/shop/${params.shopId}/charity/percentage`, requestBody);
        };
        this.deletePledgeShopCharity = (params) => {
            return this.delete(`/api/pledge/shop/${params.shopId}/charity`);
        };
        this.appAuthorizationUrl = ({ app, token, returnUrl: returnUrlParam = window.location.toString(), }) => {
            const url = new URL(`${getBaseApiUrl()}/oauth2/authorization/${app}`);
            token && url.searchParams.append('access_token', token);
            const returnUrl = new URL(returnUrlParam);
            returnUrl.searchParams.append('connected', '');
            url.searchParams.append('return_url', returnUrl.toString());
            return url;
        };
    }
}
export const CreatorIntegrationsApiClient = new CreatorIntegrationsApiClientModel(getBaseApiUrl());
